module.exports = __webpack_public_path__ + "static/media/share-bg-gradient-two.211125c8.svg";